/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import { respGridUtil } from '@marriott/mi-headless-utils';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CardCarouselContainer,
  CardLayered,
  Text,
  CardHorizontalMini,
  BannerLayered,
  CardVertical,
  CardHorizontalFeature,
  VariableColumnContainer,
  BannerText,
  Footer,
  DynamicWrapper,
} from '@marriott/mi-common-static-components';
import {
  AwpHeroBannerEditable,
  OutletDetailsEditable,
  SearchFormEditable,
  SearchResultsEditable,
  AwpErrorMessageEditable,
  CollageEditorialEditable,
  HomePageEditorialEditable,
  CondensedFeatureEditable,
  PromotionBannerEditable,
  BonvoyMemberBannerEditable,
  RecommendedMiniCardsEditable,
  HeroBannerEditable,
  CardCarouselContainerEditable,
  CardLayeredEditable,
  CardVerticalEditable,
  OffersDynamicEditable,
  OverviewSectionEditable,
  StaticArticlesEditable,
  FeaturedOutletsEditable,
  CampaignOffersCardContainerEditable,
  EarnPointsSectionEditable,
  RecommendedOutletsEditable,
  NavigationTabEditable,
  DualCardContainerEditable,
  GolfCourseLocationsEditable,
  GolfServicesEditable,
  GolfContactDetailsEditable,
  GolfEventSchedulerEditable,
  GolfBioCardsContainerEditable,
  AwpRichTextEditable,
  AwpFAQAccordionWrapperEditable,
  PropertyDetailsEditable,
  TabEditableComponent,
  RecommendationsContainerEditable,
  SignatureChefContainerEditable,
  BestOfComponentEditable,
  GroupDiningComponentEditable,
} from '@marriott/mi-awp-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';

export const AEM_REACT_MAPPING = {
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`]: AwpHeroBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/outletinfo`]: OutletDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform`]: SearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awperror`]: AwpErrorMessageEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults`]: SearchResultsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`]: CardCarouselContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardlayered`]: CardLayeredEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardvertical`]: CardVerticalEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/dynamicoffers`]: OffersDynamicEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialcollage`]: CollageEditorialEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialfeature`]: HomePageEditorialEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/condensedfeature`]: CondensedFeatureEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/promotionalbanner`]: PromotionBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bannerwithbutton`]: BonvoyMemberBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendation`]: RecommendedMiniCardsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner`]: HeroBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/overview`]: OverviewSectionEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/articlecards`]: StaticArticlesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/featuredoutlet`]: FeaturedOutletsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/offersCardContainer`]: CampaignOffersCardContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/earnpointsprogramdetails`]: EarnPointsSectionEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendationscardcontainer`]: RecommendedOutletsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`]: AwpRichTextEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awpaccordionenhanced`]: AwpFAQAccordionWrapperEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/navigationtab`]: NavigationTabEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golf-container`]: DualCardContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golflocationscard`]: GolfCourseLocationsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfservices`]: GolfServicesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfcontact`]: GolfContactDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/eventschedulecomponent`]: GolfEventSchedulerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`]: GolfBioCardsContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/propertydetails`]: PropertyDetailsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`]:
    RecommendationsContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signatureandchefcomponent`]: SignatureChefContainerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bestofcomponent`]: BestOfComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/groupdining`]: GroupDiningComponentEditable,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  ['mi-aem-common-spa/components/content/cardhorizontalfeature']: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabEditableComponent,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/common/dynamicwrapper`]: DynamicWrapper,
};

export const AEM_REACT_TITLE_MAPPING = {
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`]: 'AwP Hero Banner',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/outletinfo`]: 'Outlet Info',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform`]: 'Search Form Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awperror`]: 'AwP Error Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults`]: 'Search Results component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`]: 'Card Carousel Container',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardlayered`]: 'Card Layered',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardvertical`]: 'Card Vertical',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/dynamicoffers`]: 'Dynamic AwP Offers Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialcollage`]: 'Editorial Collage',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialfeature`]: 'Editorial Feature',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/condensedfeature`]: 'Condensed Feature',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/promotionalbanner`]: 'AwP Promotional Banner',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bannerwithbutton`]: 'Marriott Bonvoy Member Banner',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendation`]: 'Mini Cards Recommendation',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner`]: 'Hero Banner',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/overview`]: 'Overview Section',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/articlecards`]: 'Articles card component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/featuredoutlet`]: 'Featured Outlets',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/offersCardContainer`]: 'AwP Offers Card Container',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/earnpointsprogramdetails`]: 'Earn Points Info Section',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendationscardcontainer`]: 'Recommended Outlets',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`]: 'Awp Rich Text',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awpaccordionenhanced`]: 'Awp FAQ Accordion Wrapper',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/navigationtab`]: 'Navigation Bar',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golf-container`]: 'Golf Container',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golflocationscard`]: 'Golf Locations',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfservices`]: 'Golf Services',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfcontact`]: 'Golf Contact component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/eventschedulecomponent`]: 'Event Schedule Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`]: 'Bio Cards Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/propertydetails`]: 'Property Details Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`]: 'Recommendations Container',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signatureandchefcomponent`]: 'Signature and Chef Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bestofcomponent`]: 'Best Of Component',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/groupdining`]: 'Group Dining',
  'mi-aem-common-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-common-spa/components/content/cardcarouselcontainer': 'Card Carousel Container',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-common-spa/components/content/cardvertical': 'Card Vertical',
  'mi-aem-common-spa/components/content/text': 'Text',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-common-spa/components/content/cardhorizontalfeature': 'Card Horizontal Feature',
  'mi-aem-common-spa/components/content/tabcontainer': 'Tab Container',
  'mi-aem-common-spa/components/content/variablecolumncontainer': 'Variable Column Container',
  'mi-aem-common-spa/components/content/bannertext': 'Banner Text',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
  'mi-aem-common-spa/components/content/globalnav/global-navigation': 'Global Navigation',
  'mi-aem-common-spa/components/content/globalnav/utilityNavigation': 'Utility Navigation',
  'mi-aem-common-spa/components/content/globalnav/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/common/dynamicwrapper': 'Dynamic Phoenix Wrapper',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, featureFlags) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/outletinfo`)(
      props => <OutletDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OutletDetails',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform`)(
      props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'SearchForm',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults`)(
      props => <SearchResultsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'SearchResults',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awperror`)(
      props => <AwpErrorMessageEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'ErrorMessage',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/awpaccordionenhanced`)(
      props => (
        <AwpFAQAccordionWrapperEditable {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      ),
      {
        emptyLabel: 'AwpFAQAccordionWrapper',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    });
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`)(
      props => <AwpHeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OutletHeroBanner',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialcollage`)(
      props => <CollageEditorialEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'editorialcollage',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/editorialfeature`)(
      props => <HomePageEditorialEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'editorialfeature',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/condensedfeature`)(
      props => <CondensedFeatureEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CondensedFeature',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/promotionalbanner`)(
      props => <PromotionBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'promotionalbanner',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendation`)(
      props => <RecommendedMiniCardsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'recommendation',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner`)(
      props => <HeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'herobanner',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/overview`)(
      props => <OverviewSectionEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'overview',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/articlecards`)(
      props => <StaticArticlesEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'articlecards',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/featuredoutlet`)(
      props => <FeaturedOutletsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'featuredoutlet',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/dynamicoffers`)(
      props => <OffersDynamicEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'dynamicoffers',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`)(props => (
      <CardCarouselContainerEditable {...props} isAuthorMode={isAuthorMode} />
    ));

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardlayered`)(CardLayeredEditable);

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/cardvertical`)(CardVerticalEditable);

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bannerwithbutton`)(
      props => <BonvoyMemberBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'bannerwithbutton',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/earnpointsprogramdetails`)(
      props => <EarnPointsSectionEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'earnpointsprogramdetails',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/recommendationscardcontainer`)(
      props => <RecommendedOutletsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'RecommendedOutlets',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/termandcondition`)(
      props => <AwpRichTextEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'RichText',
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/offersCardContainer`)(
      props => <CampaignOffersCardContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'offerscard',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/navigationtab`)(
      props => <NavigationTabEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'navigationtab',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golf-container`)(
      props => <DualCardContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'golfcontainer',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golflocationscard`)(
      props => <GolfCourseLocationsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'golflocationscard',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfservices`)(
      props => <GolfServicesEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'golfservices',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/golfcontact`)(
      props => <GolfContactDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'golfcontact',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/eventschedulecomponent`)(
      props => <GolfEventSchedulerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'eventschedulecomponent',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`)(
      props => <GolfBioCardsContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'biocardscomponent',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/propertydetails`)(
      props => <PropertyDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'propertydetails',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`)(
      props => <RecommendationsContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'recommendationscontainer',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signatureandchefcomponent`)(
      props => <SignatureChefContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'SignatureChefContainer',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/bestofcomponent`)(
      props => <BestOfComponentEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'bestofcomponent',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/groupdining`)(
      props => <GroupDiningComponentEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'groupdining',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
      props => <CardHorizontalMini {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'cardhorizontalmini',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);

    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);

    MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(
      props => (
        <TabEditableComponent
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          componentPath="mi-awp-components"
        />
      ),
      {
        emptyLabel: 'TabContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
      props => <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'variablecolumncontainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);

    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);

    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
      <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));

    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);

    MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} isAuthorMode={isAuthorMode} />, {
      emptyLabel: 'text',
      isEmpty: false,
    });

    MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
      emptyLabel: 'Footer',
      isEmpty: false,
    });

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);
    MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(props => (
      <NavigationContainerWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        featureFlagLogo={featureFlags?.featureFlagLogo}
      />
    ));

    MapTo(`mi-aem-common-spa/components/content/globalnav/utilityNavigation`)(NavigationUtilityLinkWrapper);

    MapTo(`mi-aem-common-spa/components/content/globalnav/primaryNavigation`)(NavigationWrapper);

    MapTo(`mi-aem-common-spa/components/common/dynamicwrapper`)(DynamicWrapper);

    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };

    MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
        />
      );
    }, ExperienceFragmentVariationConfig);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
